import Routing from 'fos-router';
import routes  from '../../../../CustomerBundle/public/js/data/fos_js_routes';

const sessionControllers = new Map();

const StoreSession = async storageIds => {
    
    Routing.setRoutingData( routes );

    const requestId = storageIds.join('');

    if( '' == requestId.trim() )
        return;

    if (sessionControllers.has( requestId )) {
      sessionControllers.get( requestId ).abort();
    }

    const controller = new AbortController();
    sessionControllers.set( requestId, controller);


    try {
        let storageData = {};
        storageIds.forEach( ( k ) => {
            const storageVal = localStorage.getItem( k );
            if( storageVal.trim() ) {
                storageData[ k ] = storageVal;
            }
        });

        const options = {
            method: 'POST',
            body: JSON.stringify( storageData ),
            signal: controller.signal,
            headers: {
                'Content-Type': 'application/json'
            }
        };

        const url = Routing.generate('customer_save_session');

        const response = await fetch(url, options);
        if (!response.ok) {
            throw new Error(`Response status: ${response.status}`);
        }

        const data = await response.json();
        if (data.success) {
            if (data.added) {
                target.classList.add('active');
            }
        }

        sessionControllers.delete( requestId );

    } catch ( err ) {    
        if( err.name === 'CanceledError') 
            return;
        //throw err;
    } 
}

export default StoreSession;
